import { type ProfilePictureProps } from '@/components/profile-picture/props';
import { TvAvatarRoundWithBorder } from '@nosinovacao/fe-icons';
import { cn, useI18n, useImgSrcWithFallback } from '@nosinovacao/nosid-mfe-common';

export function AvatarPictureLight({
  size,
  name,
  src: originalSrc,
  className,
}: Readonly<ProfilePictureProps>) {
  const { t } = useI18n();
  const { handleError, src, isFallback, handleLoad, isLoading } = useImgSrcWithFallback(
    originalSrc ?? null,
    '',
  );
  return (
    <div className={cn('relative isolate', className)} style={{ width: size, height: size }}>
      {isFallback || isLoading ? (
        <TvAvatarRoundWithBorder
          className="absolute inset-0 -z-10 text-nos-neutral-75"
          width={size}
          height={size}
          aria-label={t('TvProfiles.AvatarPictureAlt', { name: name }).toString()}
        />
      ) : null}
      {isFallback ? null : (
        <img
          className="shrink-0 rounded-full border-2 border-nos-neutral-75"
          src={src}
          alt={t('TvProfiles.AvatarPictureAlt', { name: name }).toString()}
          onError={handleError}
          onLoad={handleLoad}
          width={size}
          height={size}
        />
      )}
    </div>
  );
}
